export default __webpack_public_path__ + "static/media/cell_phone.2019cf27.png";